import React from "react";

const CheckBox = (props) => {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        handleChange,
        ddTypeCodMngr
    } = props;

    const handleCheckBoxChecked = ({ target: input }) => {
        if (!input.checked) {
            input.value = "";
        }
        handleChange(input);
    };

    const getCheckboxCodeManager = (id) => {
        if (ddTypeCodMngr) {
            const ddType = ddTypeCodMngr.find((x) => x.controlId === id);
            if (ddType && Array.isArray(ddType.optionData)) {
                return ddType.optionData;
            }
        }
        return [];
    };

    const chkCodemanager = getCheckboxCodeManager(controleId);

    return (
        <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
            {comp.label && chkCodemanager.length > 0 && (
                <label className="form-control-label" style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.7px",
                    marginBottom: "8px",
                    display: "block"
                }}>
                    {comp.label}
                </label>
            )}

            {chkCodemanager.length > 0 ? (
                chkCodemanager.map((item, key) => {
                    const inputId = `${controleId}${key}`;
                    return (
                        <div key={inputId} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={inputId}
                                name={inputId}
                                value={item.name}
                                checked={data[inputId] === item.name}
                                onChange={handleCheckBoxChecked}
                                disabled={isDisabled}
                                style={{ cursor: "pointer", width: "16px", height: "16px", marginRight: "8px" }}
                            />
                            <label className="custom-control-label" htmlFor={inputId} style={{
                                fontSize: "13.5px",
                                fontFamily: "Inter, Roboto, sans-serif",
                                color: "#1e293b",
                                cursor: "pointer",
                                userSelect: "none",
                                marginBottom: 0
                            }}>
                                {item.name}
                            </label>
                            {errors[inputId] && (
                                <div className="alert alert-danger ml-3 d-inline-block" style={{ margin: 0, padding: "2px 8px", fontSize: "11px", borderRadius: "5px" }}>
                                    {errors[inputId]}
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id={controleId}
                        name={controleId}
                        value="Yes"
                        checked={data[controleId] === "Yes"}
                        onChange={handleCheckBoxChecked}
                        disabled={isDisabled}
                        style={{ cursor: "pointer", width: "16px", height: "16px", marginRight: "8px" }}
                    />
                    <label className="custom-control-label" htmlFor={controleId} style={{
                        fontSize: "13.5px",
                        fontFamily: "Inter, Roboto, sans-serif",
                        color: "#1e293b",
                        cursor: "pointer",
                        userSelect: "none",
                        marginBottom: 0
                    }}>
                        {comp.label}
                    </label>
                    {errors[controleId] && (
                        <div className="alert alert-danger ml-3 d-inline-block" style={{ margin: 0, padding: "2px 8px", fontSize: "11px", borderRadius: "5px" }}>
                            {errors[controleId]}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CheckBox;
